export default __webpack_public_path__ + "static/media/insights.cfb18fb3.webp";